import axios from "../../utils/request";

try {
  JSON.parse(sessionStorage.getItem('GLOBAL_DATA'))
} catch (e) {
  sessionStorage.removeItem('GLOBAL_DATA')
}
const state = {
  // globalData: JSON.parse(sessionStorage.getItem('GLOBAL_DATA')),
  globalData: {},
  key: 'main',
  token: sessionStorage.getItem('CASE:LARGE_SCREEN_TOKEN'),
  mapKey: "",
  communityKey: "", // 社区Key,
  plotKey: "", // 小区Key
  visitUsers: {
    totalVisitUsers: [],
    currentMonthVisitUsers: []
  },
  tapMapCount: 0,
}

const mutations = {
  SET_TAP_MAP_COUNT(state, count) {
    state.tapMapCount = count;
  },
  SET_GLOBALDATA(state, data = {}) {
    try {
      state.globalData = data;
    } catch (error) {
      console.log(error);
    }
    // sessionStorage.setItem('GLOBAL_DATA', JSON.stringify(data))
  },
  SET_KEY(state, key) {
    state.key = key;
  },
  SET_TOKEN(state, token) {
    state.token = token;
    console.log('执行成功  修改token');
    sessionStorage.setItem('CASE:LARGE_SCREEN_TOKEN', token)

  },
  SET_MAP_KEY(state, mapKey) {
    state.mapKey = mapKey
  },
  SET_COMMUNIT_KEY(state, key) {
    state.communityKey = key;
  },
  SET_PLOT_KEY(state, key) {
    state.plotKey = key
  },
  SET_VISITUSERS(state, data) {
    state.visitUsers = data;
  }
}

const actions = {
  getGlobalData({
    commit,
    dispatch
  }) {
    dispatch('getBuildingUsers');
    // dispatch('getRiskCount')
    return new Promise(resolve => {
      axios.get("/statisticsService/mechanism/survey", {
        params: {
          subDistrict: state.mapKey,
          community: state.communityKey,
          village: state.plotKey
        }
      }).then(resp => {
        let responseData = resp.data;
        resolve(responseData)
        dispatch("getVisitUsers");
        if (!responseData) return
        commit('SET_GLOBALDATA', {
          ...state.globalData,
          ...responseData
        });

      })
    })

  },
  getToken({
    commit
  }) {
    return new Promise(resolve => {
      axios.post("/mcapi/mechanismService/openapi/datav/login").then(resp => {
        commit('SET_TOKEN', resp.data.token)
        resolve(resp.data.token)
      })
    })
  },
  changeMapCount({
    commit
  }, count) {
    commit('SET_TAP_MAP_COUNT', count)
  },
  changeMapKey({
    commit
  }, key) {
    commit("SET_MAP_KEY", key);
  },
  initAddress({
    commit
  }) {
    commit('SET_KEY', "");
    commit('SET_MAP_KEY', "")
    commit('SET_COMMUNIT_KEY', "")
    commit('SET_PLOT_KEY', "")

  },
  getVisitUsers({
    commit
  }) {
    axios.get("/statisticsService/mechanism/visitUsers", {
      params: {
        subDistrict: state.mapKey,
        community: state.communityKey,
        village: state.plotKey
      }
    }).then((resp) => {
      let response = resp.data;
      if (!response.totalVisitUsers) {
        response.totalVisitUsers = []
      }
      if (!response.currentMonthVisitUsers) {
        response.currentMonthVisitUsers = []
      }
      commit('SET_VISITUSERS', resp.data)
    });
  },
  resetData({
    commit
  }) {
    commit("SET_TAP_MAP_COUNT", 0)
  },

  getRiskCount({
    commit,
    dispatch
  }) {
    axios.get("/statisticsService/mechanism/riskCount", {
      params: {
        subDistrict: state.mapKey,
        community: state.communityKey,
        village: state.plotKey
      }
    }).then(resp => {
      commit('SET_GLOBALDATA', {
        ...state.globalData,
        users: resp.data
      })
    })
  },

  getBuildingUsers({
    commit,
    dispatch
  }) {
    axios.get("/statisticsService/mechanism/survey/buildingUsers", {
      params: {
        subDistrict: state.mapKey,
        community: state.communityKey,
        village: state.plotKey
      }
    }).then(resp => {
      commit('SET_GLOBALDATA', {
        ...state.globalData,
        buildingUsers: resp.data
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
